
import type {
  AddPlanParameterReq,
  EditPlanParameterReq,
  BaseErrorResponse,
  EmptySuccessResponse,
  GetPlanParameterRes,
  GetPlanParameterValuesRes,
  GetPlanParametersRes,
  SetPlanParameterValuesReq,
} from './data-contracts';
import type { RequestParams } from './http-client';
import { ContentType, HttpClient } from './http-client';


export default function usePlanParameter() {
  class PlanParameter<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
    /**
     * No description
     *
     * @tags Plan parameter
     * @name PlanParameterControllerGetPlanParameters
     * @summary Get plan parameters list
     * @request GET:/api3/plan-parameter
     * @secure
     * @response `200` `GetPlanParametersRes`
     * @response `400` `BaseErrorResponse`
     */
    planParameterControllerGetPlanParameters = (
      query?: {
        /**
         * Field type id
         * @example 1
         */
        fieldTypeId?: number;
        dictionaryItems?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetPlanParametersRes, BaseErrorResponse>({
        path: '/api3/plan-parameter',
        method: 'GET',
        query,
        secure: true,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Plan parameter
     * @name PlanParameterControllerCreatePlanParameter
     * @summary Create plan parameter
     * @request POST:/api3/plan-parameter
     * @secure
     * @response `200` `GetPlanParameterRes`
     * @response `400` `BaseErrorResponse`
     */
    planParameterControllerCreatePlanParameter = (data: AddPlanParameterReq, params: RequestParams = {}) =>
      this.request<GetPlanParameterRes, BaseErrorResponse>({
        path: '/api3/plan-parameter',
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Plan parameter
     * @name PlanParameterControllerUpdatePlanParameter
     * @summary Update plan parameter
     * @request PUT:/api3/plan-parameter/{id}
     * @secure
     * @response `200` `GetPlanParameterRes`
     * @response `400` `BaseErrorResponse`
     */
    planParameterControllerUpdatePlanParameter = (id: number, data: EditPlanParameterReq, params: RequestParams = {}) =>
      this.request<GetPlanParameterRes, BaseErrorResponse>({
        path: `/api3/plan-parameter/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Plan parameter
     * @name PlanParameterControllerDeletePlanParameter
     * @summary Delete plan parameter
     * @request DELETE:/api3/plan-parameter/{id}
     * @secure
     * @response `200` `EmptySuccessResponse`
     * @response `400` `BaseErrorResponse`
     */
    planParameterControllerDeletePlanParameter = (id: number, params: RequestParams = {}) =>
      this.request<EmptySuccessResponse, BaseErrorResponse>({
        path: `/api3/plan-parameter/${id}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Plan parameter
     * @name PlanParameterControllerUpdatePlanParameterValue
     * @summary Update plan parameter value
     * @request PUT:/api3/plan-parameter/{id}/values
     * @secure
     * @response `200` `GetPlanParameterValuesRes`
     * @response `400` `BaseErrorResponse`
     */
    planParameterControllerUpdatePlanParameterValue = (
      id: number,
      data: SetPlanParameterValuesReq,
      params: RequestParams = {},
    ) =>
      this.request<GetPlanParameterValuesRes, BaseErrorResponse>({
        path: `/api3/plan-parameter/${id}/values`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      });
  }

  return new PlanParameter();
}
